import { StartController } from './start.controller';
import template from './start.html';

export const startComponent = {
  name: 'startComponent',
  restrict: 'E',
  template,
  controller: StartController,
  controllerAs: 'vm',
  bindings: {}
};



// WEBPACK FOOTER //
// ./src/app/components/start/start.component.js